import 'css-chunksrc/client/scenes/comments/feed/comment/styles.scss';export default {
  "comment": "_comment_znfac_1",
  "iconBox": "_iconBox_znfac_10",
  "ownComment": "_ownComment_znfac_14",
  "pending": "_pending_znfac_25",
  "avatar": "_avatar_znfac_29",
  "main": "_main_znfac_35",
  "header": "_header_znfac_44",
  "author": "_author_znfac_51",
  "role": "_role_znfac_58",
  "submissionDate": "_submissionDate_znfac_62",
  "content": "_content_znfac_68",
  "icon": "_icon_znfac_10",
  "replyButton": "_replyButton_znfac_156",
  "replies": "_replies_znfac_169"
};